
function lineAnimation(section) {

	if(section == 'links__item') {
		var content = $('.links__item');
	} else {
		var content = $('.location');
	}

	if(content.length > 0) {
	
		var path_width = $(window).width();
		
		content.each(function( index ) {

			gsap.defaults({ease: "elastic(1, 1.5)"});

			var svg  = $(this).find('svg')[0];
			var path = $(this).find('path')[0];
			var offsetTop = $(this).find('svg').offset().top;

			var connected = false;
			var snapDist = 40;
			var startY = 75;

			// Break the path down into points
			// <path d="M200,200 Q 400,200 600,200" />
			var p0 = { x: 0, y: startY };
			var p1 = { x: path_width / 2, y: startY };
			var p2 = { x: path_width, y: startY };

			svg.addEventListener("mousemove", onMove);

			gsap.ticker.add(update);
			update();

			function update() {
			   
			  var d = "M" + p0.x + "," + p0.y + " Q" + p1.x + "," + p1.y + " " + p2.x + "," + p2.y;
			  
			  path.setAttribute("d", d);

			  if (Math.abs(p1.y - startY) > snapDist * 2) {    
			    connected = false;
			    gsap.to(p1, { duration: 1,  y: startY });
			  }  
			}

			function onMove(event) {

				if (!connected && event.target === path) {    
			    	connected = true;    
			    	gsap.killTweensOf(p1); // Kill any active tweens on the point
			  	}
			  
			  	if (connected) {    

			  		var scrollDist = event.pageY - offsetTop;
					p1.y = scrollDist * 2 - (p0.y + p2.y) / 2;

				}
			}
		});
	}
}

window.addEventListener("resize", () => {
	lineAnimation();
});